import { Component, Input } from '@angular/core'
import { Footnote } from 'src/app/models/footnote.model'
import { NavArr, Returns } from 'src/app/models/performance-response.model'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

@Component({
  selector: 'performance-quarterly',
  templateUrl: './performance-quarterly.component.html',
  styleUrls: ['./performance-quarterly.component.scss'],
})
export class PerformanceQuarterlyComponent {
  @Input() data: Returns
  @Input() profileData: any
  @Input() benchmarkFootNote: Footnote
  @Input() marketPriceFootNote: Footnote

  count = 0

  type = 'nav'
  tableData: NavArr

  constructor(public adobeLaunchService: AdobeLaunchService) {}

  ngOnChanges(changes: any) {
    if (changes?.profileData && this.profileData?.isETF) {
      this.type = 'marketPrice'
    }
    this.onChange(this.type)
  }

  // eslint-disable-next-line complexity, max-statements
  onChange(event) {
    if (
      this.data !== null &&
      this.data[event] !== undefined &&
      this.data[event].length > 0
    ) {
      if (event === 'marketPrice') {
        document
          .getElementById('Market')
          ?.classList.add('c11n-segmented-control__segment--active')
        document
          .getElementById('Nav')
          ?.classList.remove('c11n-segmented-control__segment--active')
      } else {
        document
          .getElementById('Nav')
          ?.classList.add('c11n-segmented-control__segment--active')
        document
          .getElementById('Market')
          ?.classList.remove('c11n-segmented-control__segment--active')
      }
      if (this.count > 1) {
        this.adobeLaunchService.subPageTabEvent(
          `${this.profileData?.ticker}:totalreturns:quarterly:toggle:${event}`,
        )
      }
      this.tableData = this.data[event][0].item
      this.count++
    }
  }
}
